var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85834 7.5L12.5 10.1333V10C12.5 9.33696 12.2366 8.70107 11.7678 8.23223C11.2989 7.76339 10.6631 7.5 10 7.5H9.85834ZM6.27501 8.16667L7.56668 9.45833C7.52501 9.63333 7.50001 9.80833 7.50001 10C7.50001 10.663 7.7634 11.2989 8.23224 11.7678C8.70108 12.2366 9.33697 12.5 10 12.5C10.1833 12.5 10.3667 12.475 10.5417 12.4333L11.8333 13.725C11.275 14 10.6583 14.1667 10 14.1667C8.89494 14.1667 7.83513 13.7277 7.05373 12.9463C6.27233 12.1649 5.83334 11.1051 5.83334 10C5.83334 9.34167 6.00001 8.725 6.27501 8.16667ZM1.66668 3.55833L3.56668 5.45833L3.94168 5.83333C2.56668 6.91667 1.48334 8.33333 0.833344 10C2.27501 13.6583 5.83334 16.25 10 16.25C11.2917 16.25 12.525 16 13.65 15.55L14.0083 15.9L16.4417 18.3333L17.5 17.275L2.72501 2.5M10 5.83333C11.1051 5.83333 12.1649 6.27232 12.9463 7.05372C13.7277 7.83512 14.1667 8.89493 14.1667 10C14.1667 10.5333 14.0583 11.05 13.8667 11.5167L16.3083 13.9583C17.5583 12.9167 18.5583 11.55 19.1667 10C17.725 6.34167 14.1667 3.75 10 3.75C8.83334 3.75 7.71668 3.95833 6.66668 4.33333L8.47501 6.125C8.95001 5.94167 9.45834 5.83333 10 5.83333Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close-eye.9615db957aa0f16a47a99033ffa805a3.svg";
export { ForwardRef as ReactComponent };